import { Plus, UserPlusIcon } from 'lucide-react'

import { partnersProspects, partnersQuoteRequest, partnersQuotes } from 'rails_routes'
import { ButtonLink } from 'slab'
import { usePostQuotingProspects } from 'utils/web_api'

import RequestAQuotePanel from './RequestAQuotePanel'

interface RequestAQuoteButtonProps {
  isPrimary?: boolean
  useMultiStepQuoteRequestFlow?: boolean
  location?: string
  canSelfServeQuotes?: boolean
  prospectId?: string
}

export default function RequestAQuoteButton ({
  isPrimary = true,
  useMultiStepQuoteRequestFlow = false,
  location,
  canSelfServeQuotes,
  prospectId,
} : RequestAQuoteButtonProps) {
  const { mutate: createProspect } = usePostQuotingProspects({
    mutation: {
      onSuccess: (data) => {
        window.segment?.track('Enter quote request', { id: data.id })
        window.location.href = partnersQuoteRequest.show({ id: data.id })
      }
    },
    request: {
      get body () {
        const formData = new FormData()
        formData.append('is_quote_request', String(true))
        return formData
      }
    }
  })
  if (canSelfServeQuotes) {
    return (
      <ButtonLink
        href={prospectId ? partnersQuotes.new({ prospect_id: prospectId }) : partnersProspects.new()}
        variant={isPrimary ? 'primary' : 'secondary'}
      >
        <div className='flex items-center gap-2'>
          <UserPlusIcon size={21} />
          Create a quote
        </div>
      </ButtonLink>
    )
  }

  const requestButton = (
    <button
      className={isPrimary ? 'btn-primary' : 'btn-secondary'}
      onClick={() => {
        window.segment?.track(
          '[TfB] Quote request form opened',
          { location }
        )
        if (useMultiStepQuoteRequestFlow) {
          // Create a draft prospect and navigate to its request flow
          createProspect()
        }
      }}
    >
      <Plus size={21} className='mr-2' />
      Request a quote
    </button>
  )

  if (useMultiStepQuoteRequestFlow) {
    return requestButton
  }

  return (
    <RequestAQuotePanel triggerChildren={requestButton} />
  )
}
